import React from 'react';
import { withRouter } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';

import { ValueFieldData, RequiredValidator, PositiveValueValidator } from 'lib/form/value-field-data';
import FormView from 'lib/form/form-view';
import { Form, Field } from 'lib/form/form';
import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import medal from 'four-nets/icons/svg/icon_medal.svg';

import SubmitButtonView from 'four-nets/ui/submit-button/submit-button-view';
import FieldWithLabelView from 'four-nets/ui/form/field-with-label-view';
import withStackViewForm from 'four-nets/ui/with-stack-view-form';
import TextAreaView from 'four-nets/ui-v2/form/text-area/text-area';
import StarsInputView from 'four-nets/ui/form/stars-input-view';
import BazaarProfileLoader from 'four-nets/bazaar/profile/bazaar-profile-loader';

import bazaarProfileViewStyles from './bazaar-profile-view.scss';
import defaultStyles from './create-edit-review-view.scss';


class CreateEditReviewForm extends Form {
    constructor(options) {
        const { rating, message = '' } = options;
        super({
            ...options,
            field: {
                rating: new Field({
                    data: new ValueFieldData({
                        value: rating,
                        validators: [new RequiredValidator(), new PositiveValueValidator()],
                    }),
                }),
                message: new Field({
                    data: new ValueFieldData({
                        value: message,
                        validators: [new RequiredValidator()],
                    }),
                }),
            },
        });
    }
}

export class CreateEditReviewViewModel {
    reviewStore: ReviewStore;
    product: Product;
    buyer: Buyer;
    @observable form: Form;

    constructor(reviewStore, buyer, review) {
        this.reviewStore = reviewStore;
        this.buyer = buyer;
        this.review = review;

        this.form = new CreateEditReviewForm({
            handleSubmit: this.handleSubmit,
        });
    }

    handleSubmit = ({
        data,
    }: {
        form: Form,
        data: {
            message: String,
            rating: number,
        },
    }) => {
        const { message, rating } = data;

        if (this.review) {
            return this.review.edit(message, rating);
        }
        return this.reviewStore.create(this.buyer, message, rating);
    };
}

@withStackViewForm({
    title: <FormattedMessage id='REVIEW_FORM_TITLE' />,
})
@Styled(defaultStyles)
@observer
class CreateEditReviewView extends React.Component {
    customSubmit = () => {
        const promise = this.props.form.submit();
        return promise.finally(this.props.forceUpdate);
    };

    render() {
        const { createEditReviewViewModel, product, buyer, isAuthor, styles } = this.props;
        const { form } = createEditReviewViewModel;
        const { valid, dirty } = form;

        return (
            <div className={styles.wrapper}>
                <BazaarProfileLoader
                    user={isAuthor ? buyer.user : product.user}
                    styles={bazaarProfileViewStyles}
                    hideEdit={true}
                />
                <FormView form={form} submitOnEnter={false} submit={this.customSubmit}>
                    <div className={styles.fieldWrapper} key='rating'>
                        <FieldWithLabelView
                            key='rating'
                            field={<StarsInputView onChange={form.field.get('rating').data.onChange} />}
                            label={<FormattedMessage id='BAZAAR_NEW_RATING' />}
                            id='rating'
                        />
                    </div>
                    <div className={styles.fieldWrapper} key='message'>
                        <TextAreaView
                            field={form.field.get('message')}
                            type='text'
                            id='message'
                            className={styles.textInput}
                            emojify={false}
                        />
                    </div>
                    <div className={styles.submitButtonWrapper}>
                        <SubmitButtonView disabled={!(valid && dirty)} onClick={this.customSubmit}>
                            <SVGIcon style={{image: styles.icon}} src={medal} />
                            <span className={styles.submitButton}>
                                {<FormattedMessage id='BUTTON_LABEL_SAVE_REVIEW' />}
                            </span>
                        </SubmitButtonView>
                    </div>
                </FormView>
            </div>
        );
    }
}

export default withRouter(CreateEditReviewView);
